export const getClientMap = (row, all) => {
  const { client } = row
  const map = new Map([
    [1, '微信小程序'],
    [2, '支付宝小程序']
    // [3, '抖音小程序'],
    // [4, '乘客端app']
  ])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(client) && map.get(client)) || ''
}

export const getStatusMap = (row, all) => {
  const { client } = row
  const map = new Map([
    [1, '待生效'],
    [2, '生效中'],
    [3, '已失效']
  ])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(client) && map.get(client)) || ''
}

export const getOperateType = (row, all) => {
  const { type } = row
  const map = new Map([
    [1, '新增'],
    [2, '修改'],
    [3, '删除']
  ])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(type) && map.get(type)) || ''
}

export const getOperatorList = (row, all) => {
  const { operator } = row
  const map = new Map([[2, '系统管理员-后台']])
  if (all) {
    const arr = []
    for (const [key, value] of map) {
      arr.push({
        label: value,
        value: key
      })
    }
    return arr
  }
  return (map.has(operator) && map.get(operator)) || ''
}
